import styled, { css, keyframes } from 'styled-components';
import Image from 'global/Image';
import { Button } from 'antd';

export const counterSpinAnimation = keyframes`
  100% {
    transform: rotate(-360deg);
  }
`;

export const counterSpinCss = css`
  & > .anticon {
    animation: ${counterSpinAnimation} 1s linear 0s infinite forwards;
  }
`;

export const ErrorIcon = styled(Image)<{ width?: string; height?: string }>`
  margin-bottom: 4px;
  width: ${({ width = 'auto' }) => `${width}`};
  height: ${({ height = 'auto' }) => `${height}`};
`;

export const RetryButton = styled(Button)<{ spin?: boolean }>`
  color: #00ab6b;
  font-weight: bold;

  &:hover,
  &:focus,
  &:active {
    color: #00ab6b;
  }

  & > .anticon {
    width: 13px;
    height: 13px;
    vertical-align: middle;
    transform: rotate(0deg);
    transition: transform 0.3s linear;
  }

  ${({ spin }) => (spin ? counterSpinCss : '')}

  margin: 0 !important;
`;
